import { ExpandCollapseButtons } from '@components/_SiteWide/ExpandCollapseButtons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import React, { useState } from 'react'

export function PriceGrouping(params) {
  const [hasExpandedNodes, setHasExpandedNodes] = useState(params.node.expanded)

  if (params?.node?.field === 'product') {
    return (
      <Horizontal verticalCenter>
        <Texto style={{ height: '100%' }} weight='bold'>
          {params?.value}
        </Texto>
      </Horizontal>
    )
  }

  const expandOverride = () => {
    params.node.childrenAfterGroup.forEach((node) => node.setExpanded(true))
    setHasExpandedNodes(true)
  }
  const collapseOverride = () => {
    params.node.childrenAfterGroup.forEach((node) => node.setExpanded(false))
    setHasExpandedNodes(false)
  }

  return (
    <Horizontal gap={8} verticalCenter>
      <ExpandCollapseButtons
        type='ghost'
        isExpanded={hasExpandedNodes}
        gridAPIRef={params.api}
        collapseOverride={collapseOverride}
        expandOverride={expandOverride}
      />
      <Texto category='p2' style={{ height: '100%' }} className='ml-2' weight='bold'>
        {params?.value}
      </Texto>
    </Horizontal>
  )
}
